import { InAppComponent, useGetInAppComponentsLogs } from '../query/useGetInappComponentsLogs';

export const useGetSingleInAppComponentLog = (customerId: string, inAppComponent: InAppComponent) => {
  const { data: inAppComponentLogs = [], isLoading, refetch } = useGetInAppComponentsLogs({ customerId });
  const filteredLogs = inAppComponentLogs.filter((item) => item.name === inAppComponent);

  return { data: filteredLogs?.[0], isLoading, refetch };
};
